import UserInterface from '@/interfaces/User';
import axios from 'axios';
import store from "@/store";
import { Data } from 'vue';

class UserService {

  async financeiro(data: { filter: { search: string; dataInicio: Data; dataFim: Data }; pagination: { page: number; itensPerPage: number } }) {
    return await axios.post("user/financeiro", data).then(
      resp => {
        return resp.data;
      }
    ).catch(
      error => {
        return false;
      }
    )
  }

  async removeDeviceToken(data: { expoDeviceToken?: string; firebaseDeviceToken?: string; apnsDeviceToken?: string }) {
    return await axios.post("user/removeDeviceToken", data).then(
      resp => {
        return resp.data.statusCode === 200 ? true : false;
      }
    ).catch(
      error => {
        return false;
      }
    )
  }

  async deviceInfoUpdate(data: { expoDeviceToken?: string; firebaseDeviceToken?: string; apnsDeviceToken?: string }) {
    return await axios.post("user/device", data).then(
      resp => {
        return resp.data.statusCode === 200 ? true : false;
      }
    ).catch(
      error => {
        return false;
      }
    )
  }

  findAll(paginacao: any, filtro: { search: string; situacao: string; role: string }) {
    const dtOptions = {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
    };

    const parsedFiltro = {
      searchStr: filtro.search,
      situacao: filtro.situacao,
      role: filtro.role
    }

    return axios.get("user/all/", { headers: { 'pagination': JSON.stringify(paginacao), 'filter': JSON.stringify(parsedFiltro) } }).then(
      resp => {
        if (!Array.isArray(resp.data)) {
          return Promise.reject(resp.data)
        }
        return {
          itens: resp.data,
          totalRegistros: +resp.headers.totalrecordcount
        }
      }
    ).catch(
      error => {
        return {
          itens: [],
          totalRegistros: 0
        }
      }
    );
  }

  findById(userId: number) {
    return axios.get(`user/${userId}`);
  }

  register(user: UserInterface) {
    user.clientCnpj = user.clientCnpj?.replace("[^0-9]", "");
    user.expoDeviceToken = store.state.User.expoDeviceToken;
    return axios.post('user', user);
  }

  passwordRecoveryRequest(dados: any) {
    return axios.put('user/password/generaterecovery', dados);
  }

  setNewMail(dados: { email: string; id?: number; username?: string }) {
    return axios.put('user/email/change', dados);
  }

  passwordRecoverySetNewPassword(newPwd) {
    return axios.put('user/password/changewithtoken', newPwd);
  }

  passwordSetNewPassword(dados: { user: string; newPassword: string; oldPwd: string }) {
    return axios.put('user/password/changewitholdpwd', dados);
  }

  alterarVinculoComCliente(usuarioId: number, newClienteId: number) {
    return axios.put("/user", { userId: usuarioId, clienteId: newClienteId });
  }

  alterarRoleUsuario(usuarioId: number, newGrupo: number) {
    return axios.put("/user", { userId: usuarioId, grupo: newGrupo });
  }

  updateUser(usuario: UserInterface) {
    return axios.put(`/user/${usuario.id}`, usuario);
  }

  deleteUser(usuarioId: number) {
    return axios.delete(`/user/${usuarioId}`);
  }

  deleteSelf() {
    return axios.delete(`/user`);
  }

  fetchLoggedUserData() {
    return axios.get(`user`);
  }

  enviarEmailContato(data: { nome: string; email: string; fone: string; mensagem: string }) {
    return axios.post(`email/contato`, data);
  }


  buscarPortadorPadrao() {
    return axios.get("user/portador");
  }

  buscarCondicaoPgtoPadrao() {
    return axios.get("user/condicaopgto");
  }

  alterarVinculoComVendedor(usuarioId: number, newVendedorId: number) {
    return axios.put("/user", { userId: usuarioId, vendedorId: newVendedorId });
  }
}

export default new UserService();
